import { render, staticRenderFns } from "./NewPromotionBaseSettings.vue?vue&type=template&id=13ac37f2&"
import script from "./NewPromotionBaseSettings.vue?vue&type=script&lang=js&"
export * from "./NewPromotionBaseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports